import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
export function WhoIsItFor() {
  const forYou = ['Has tenido candidiasis una o varias veces y quieres entender por qué', 'No sabes distinguir si lo que tienes es candidiasis u otra cosa', 'Te has automedicado y el problema vuelve', 'Quieres información clara sin tecnicismos ni alarmismo', 'Buscas mejorar tus hábitos de cuidado íntimo', 'Quieres saber exactamente cuándo debes consultar al médico', 'Estás cansada de buscar en Google sin encontrar respuestas concretas'];
  const notForYou = ['Buscas una cura milagrosa o promesas irreales', 'Prefieres seguir adivinando sin información confiable', 'Crees que ya sabes todo sin haberlo estudiado'];
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-323">
      <div className="max-w-6xl mx-auto" data-id="element-324">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-325">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-326">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-heading mb-6" data-id="element-327">
              Esta guía es para ti si:
            </h3>
            <div className="space-y-4" data-id="element-328">
              {forYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-329">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-330" />
                  <p className="text-body text-lg" data-id="element-331">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-332">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-heading mb-6" data-id="element-333">
              Esta guía NO es para ti si:
            </h3>
            <div className="space-y-4" data-id="element-334">
              {notForYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-335">
                  <XIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-336" />
                  <p className="text-body text-lg" data-id="element-337">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}